import ButtonFile from "#common/buttons/ButtonFile"
import { MasterDialog } from "#common/Dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { salariesPost } from "#salaries/services/Api"
import WarningIcon from "@mui/icons-material/Warning"
import { Button, Stack, Typography } from "@mui/material"
import Box from "@mui/material/Box"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { ChangeTitle } from "Components/menu/funciones"
import { useCallback, useMemo, useState } from "react"
const UploadPaymentFile = () => {
	ChangeTitle("Subir Pagos")
	const [excel, setExcel] = useState(null)
	const [accept, setAccept] = useState(false)
	const [data, setData] = useState(null)
	const success = useCallback((data) => {
		setData(data?.data?.data)
		setAccept(data?.data?.success || false)
	}, [])
	const { fetch } = useApiSend(salariesPost, { success })
	return (
		<Box
			display="flex"
			width="100%"
			flexDirection="column"
			gap={2}
			justifyContent={"center"}
			alignContent={"center"}
			alignItems={"center"}
		>
			<div style={{ flex: 1 }}>
				<ButtonFile
					label="Subir pagos de salarios"
					icon="upload"
					getFiles={(files) => setExcel(files[0])}
				/>
			</div>
			<Stack direction="row" spacing={2}>
				<ButtonsUploadFile
					label="Comprobar archivo"
					{...{ fetch, excel }}
					is_check
					disabled={!excel}
				/>
				<AcceptFileDialog disabled={!accept} excel={excel} />
			</Stack>
			<WarningFile data={data} setAccept={setAccept} />
		</Box>
	)
}

export default UploadPaymentFile

const ButtonsUploadFile = ({ label = "", is_check = false, excel, fetch, disabled }) => {
	return (
		<Button
			label="Enviar"
			icon="upload"
			disabled={disabled}
			onClick={() => {
				const formData = new FormData()
				// formData.append("sociedad_id", 9)
				formData.append("excel", excel)
				formData.append("check", is_check)
				fetch(formData)
			}}
		>
			{label}
		</Button>
	)
}
const WarningFile = ({ notShow, setAccept, data }) => {
	if (notShow || !data) return null

	const { warning = {} } = data

	const keys = Object.keys(warning)
	if (keys.length === 0) return null
	const tables = keys.map((key) => {
		return (
			<TableContainer component={Paper} key={key}>
				<Table sx={{ minWidth: 650 }} aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell>
								<Stack direction="row" spacing={4}>
									<WarningIcon color="error" />
									<Typography variant="h6">
										{key.toLocaleUpperCase()}
									</Typography>
								</Stack>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{warning[key].map((row) => (
							<TableRow
								key={row}
								sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
							>
								<TableCell component="th" scope="row">
									{row}
								</TableCell>
								<TableCell align="right">{row?.calories}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		)
	})

	return <Stack spacing={2}>{tables}</Stack>
}
const AcceptFileDialog = ({ disabled, excel }) => {
	const success = useCallback((data) => {
		setOpen(false)
	}, [])
	const [cancelar, setCancelar] = useState(null)
	const { fetch } = useApiSend(salariesPost, { success })
	const [open, setOpen] = useState(false)
	const buttons = useMemo(() => {
		return [
			{
				label: "Cancelar",
				onClick: () => {
					setOpen(false)
					if (cancelar) {
						cancelar()
						setCancelar(null)
					}
				},
				disabled: false,
			},
			{
				label: "Guardar",
				onClick: () => {
					const formData = new FormData()
					// formData.append("sociedad_id", 9)
					formData.append("excel", excel)
					setCancelar(() => fetch(formData))
				},
				disabled: cancelar,
			},
		]
	}, [cancelar, excel, fetch])
	return (
		<div>
			<Button disabled={disabled} onClick={() => setOpen(true)}>
				Subir Archivo
			</Button>
			<MasterDialog
				{...{ open, setOpen }}
				title="Confirmar archivo"
				maxWidth="sm"
				buttons={buttons}
			>
				<Typography variant="subtitle1">ADVERTENCIA</Typography>
				<Typography variant="subtitle2">
					El archivo se subirá y se crearan los registros de los pagos de los
					colaboradores.
				</Typography>
				<Typography variant="subtitle2">
					Los colaboradores podrán visualizar su pago en plataforma.
				</Typography>
			</MasterDialog>
		</div>
	)
}
